import { createHaNSessionStore, resetHaNSessionOnSignOut } from "@lib/logic";

import { createHaNSessionStorage } from "./session.storage";

/** Web's H&N session store. It lives as long as the browser tab; the building and previous tab survive a reload. */
export const haNSession = createHaNSessionStore(createHaNSessionStorage(() => window.sessionStorage));

// Signing out in the Teams desktop app doesn't reload the page, so the store has to forget the previous user itself
resetHaNSessionOnSignOut(haNSession);
